<div class="breadcrumb__wrapper">
    @for (segment of urlSegments; track segment; let i = $index) {
        @if (i >= 2) {
            @if (i === 2) {
                <span class="breadcrumb__segment">
                    <span class="breadcrumb__divider">/</span>
                </span>
            }
            @if (!(i | wrapFn: hideSegment)) {
                <span data-cy="breadcrumb-text" class="breadcrumb__segment" [ngClass]="{ 'breadcrumb__segment--last': i === urlSegments.length - 1 }">
                    <a
                        class="breadcrumb__link"
                        [routerLink]="i - 1 | wrapFn: getCommand"
                        [ngClass]="{ 'breadcrumb__not-active': i === urlSegments.length - 1 || (i - 1 | wrapFn: getCommand)?.length === 0 }"
                        >{{ i - 1 | wrapFn: getLabel }}</a
                    >
                    @if (i < urlSegments.length - 1) {
                        <span class="breadcrumb__divider">/</span>
                    }
                </span>
            }
        }
    }
</div>
